





import Vue from 'vue'

export default Vue.extend({
  name: 'ActiveCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      return this.params.data.status !== 3 ? 'check' : 'clear'
    },

    color (): string {
      // @ts-ignore
      return this.params.data.status !== 3 ? 'green' : 'red'
    }
  }
})
